<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{ $ml.get('shared.points') }}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{ $ml.get('shared.dashboard') }}</span>
        </li>
        <li>
          <i class="fa fa-shield"></i>
          <span>{{ $ml.get('shared.guardTourSystem') }}</span>
        </li>
        <li>
          <span>{{ $ml.get('shared.points') }}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-2" style="cursor:pointer;"
          v-for="controlPoint in controlPointList" :key="controlPoint.id">
          <div class="box">
            <div @click="selectControlPoint(controlPoint)" data-toggle="modal" data-target="#modal-control-point">
              <div class="box-body text-center">
                <span>
                  <img style="width:100px;"
                    :src="getAreaImageFromId(controlPoint.areaId) == '' || getAreaImageFromId(controlPoint.areaId) == null ? '/src/assets/buildings/office-building-19.png' : '/src/assets/buildings/' + getAreaImageFromId(controlPoint.areaId)" />
                </span>
                <br />
                <span style="font-size:12px; font-weight: bold;">{{ controlPoint.name }}</span>
              </div>
            </div>
            <div class="box-footer text-center">
              <p style="font-size:12px;">
                <span class="text-muted">{{ getAreaNameFromId(controlPoint.areaId) }}</span>
              </p>
              <button data-target="#qr-code" data-toggle="modal" @click="selectControlPoint(controlPoint)" class="btn"
                style="margin:0px;">{{ $ml.get('general.viewQRCode') }}
              </button>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-2" style="cursor:pointer;" data-toggle="modal"
          data-target="#modal-control-point" @click="newControlPoint()">
          <div class="box">
            <div class="box-body text-center text-primary">
              <span style="font-size:50px;padding-top:70px;display:inherit;">
                <i class="fa fa-plus-circle"></i>
                <h4>Yeni Kontrol Noktası Ekle</h4>
              </span>
              <br />
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- /.MODAL START-->
    <div class="modal fade" id="modal-control-point">
      <div :class="newImg ? 'modal-dialog' : 'modal-dialog'">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">
              <span v-text="controlPoint.name != '' ? controlPoint.name : 'Yeni Kontrol Noktası'"></span>
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12">
                <div class="text-center">
                  <img
                    :src="getAreaImageFromId(controlPoint.areaId) && getAreaImageFromId(controlPoint.areaId) != '' ? '/src/assets/buildings/' + getAreaImageFromId(controlPoint.areaId) : '/src/assets/buildings/office-building-19.png'"
                    style="width:200px;height:200px;" />
                  <h3>
                    <span v-text="controlPoint.name != '' ? controlPoint.name : 'Yeni Kontrol Noktası'"></span>
                  </h3>
                </div>
                <div class="form-group" style="margin-top:10px;">
                  <label>
                    <i class="fa fa-pencil"></i> Kontrol Noktası Adı
                  </label>
                  <input type="text" class="form-control" v-model="controlPoint.name" />
                </div>
                <div class="form-group" style="margin-top:10px;">
                  <label>
                    <i class="fa fa-building"></i> Bölge
                  </label>
                  <select @change="changeArea($event)" class="form-control">
                    <option>{{ $ml.get('general.select') }}</option>
                    <option v-for="area in areaList" :key="area.id" :value="area.id"
                      :selected="controlPoint.areaId == area.id">{{ area.areaName }}</option>
                  </select>
                </div>
                <div class="row" style="margin-top: 10px;">
                  <div class="col-sm-6">
                    <div class="form-group" style="margin-top:10px;">
                      <label>X Koordinatı</label>
                      <input type="text" class="form-control" v-model="controlPoint.positionX" />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group" style="margin-top:10px;">
                      <label>Y Koordinatı</label>
                      <input type="text" class="form-control" v-model="controlPoint.positionY" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="pull-left">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ $ml.get('general.cancel')
              }}</button>
            </div>
            <div class="pull-right">
              <button data-dismiss="modal" v-show="!isNewControlPoint" @click="deleteControlPoint()"
                class="btn btn-danger ">
                <i class="fa fa-trash"></i>
                {{ $ml.get('general.delete') }}
              </button>
              <button data-dismiss="modal" v-show="!isNewControlPoint" @click="saveControlPoint()"
                class="btn btn-success ">
                <i class="fa fa-refresh"></i>
                {{ $ml.get('general.update') }}
              </button>
              <button data-dismiss="modal" v-show="isNewControlPoint" @click="saveControlPoint()"
                class="btn btn-success ">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.save') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /.MODAL END -->
    <!--MODALS-->
    <div class="modal fade" id="qr-code" role="dialog">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <i class="fa fa-qrcode"></i> {{ $ml.get('general.qRCodeBarcodePrint') }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-8" id="print">
                <div :style="qrTextStyle">
                  <!--QR KOD-->
                  <qrcode-vue renderAs="svg" :value="qrValue" :size="qrSize" level="H"></qrcode-vue>
                  <!--QR KOD-->
                  <div>
                    <h2 style="margin-bottom:5px;">
                      <strong>{{ controlPoint.name }}</strong>
                    </h2>
                    <span>{{ getAreaNameFromId(controlPoint.areaId) }}</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <h4>{{ $ml.get('general.qrSettings') }}</h4>
                <hr />
                <div class="form-group">
                  <label>{{ $ml.get('general.qrSize') }}</label>
                  <input type="number" class="form-control" v-model="qrSize" />
                </div>
                <div class="btn-group">
                  <button @click="qrTextStyle = 'text-align:left;'" type="button"
                    :class="qrTextStyle == 'text-align:left;' ? 'btn btn-primary ' : 'btn btn-default '">
                    <i class="fa fa-align-left"></i>
                  </button>
                  <button @click="qrTextStyle = 'text-align:center;'" type="button"
                    :class="qrTextStyle == 'text-align:center;' ? 'btn btn-primary ' : 'btn btn-default '">
                    <i class="fa fa-align-center"></i>
                  </button>
                  <button @click="qrTextStyle = 'text-align:right;'" type="button"
                    :class="qrTextStyle == 'text-align:right;' ? 'btn btn-primary ' : 'btn btn-default '">
                    <i class="fa fa-align-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ $ml.get('general.cancel')
            }}</button>
            <button type="button" class="btn btn-warning" @click.prevent="print()">
              <i class="fa fa-print"></i> {{ $ml.get('general.print') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--END MODALS-->
  </div>
</template>
<script>
import myUpload from "vue-image-crop-upload";
import QrcodeVue from "qrcode.vue";
export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      uploadValue: 0,
      imageData: null,
      tempUrl: null,
      showImageDialog: false,
      params: {},
      headers: {},
      qrValue: "",
      qrSize: 200,
      qrTextStyle: "text-align:center;",
      searchText: "",
      newImg: true,
      isNewControlPoint: true,
      controlPoint: {
        id: null,
        areaId: null,
        name: "",
        imagePath: "",
        positionX: "",
        positionY: ""
      },
      controlPoints: [],
      areas: []
    };
  },
  components: {
    "my-upload": myUpload,
    QrcodeVue
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  computed: {
    authControl() {
      return this.$store.getters.getAuthBekciTur;
    },
    modules() {
      return this.$store.getters.getModules;
    },
    buildings() {
      return this.$store.getters.getBuildings;
    },
    imgList() {
      if (this.searchText != "") {
        return this.buildings.filter(a => {
          return this.searchText
            .toLowerCase()
            .split(" ")
            .every(v => a.tags.toLowerCase().includes(v));
        });
      } else {
        return this.buildings;
      }
    },
    areaList() {
      return this.areas;
    },
    controlPointList() {
      return this.controlPoints;
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    print() {
      this.$htmlToPaper("print");
    },
    changeArea(event) {
      this.controlPoint.areaId = event.target.value;
      var area = this.areaList.filter(a => {
        return a.id == event.target.value;
      });
      if (area[0]) {
        this.controlPoint.imagePath = area[0].imagePath;
      } else {
        this.controlPoint.imagePath = "";
      }
    },
    getAreaImageFromId(areaId) {
      var area = this.areaList.filter(a => {
        return a.id == areaId;
      });
      if (area[0]) {
        return area[0].imagePath;
      } else {
        return "office-building-19.png";
      }
    },
    getAreaNameFromId(areaId) {
      var area = this.areaList.filter(a => {
        return a.id == areaId;
      });
      if (area[0]) {
        return area[0].areaName;
      } else {
        return "";
      }
    },
    newControlPoint() {
      this.isNewControlPoint = true;
      this.controlPoint.id = null;
      this.controlPoint.areaId = null;
      this.controlPoint.name = "";
      this.controlPoint.imagePath = "office-building-19.png";
      this.controlPoint.positionX = "";
      this.controlPoint.positionY = "";
    },
    selectControlPoint(controlPoint) {
      this.isNewControlPoint = false;
      this.controlPoint.id = controlPoint.id;
      this.controlPoint.areaId = controlPoint.areaId;
      this.controlPoint.name = controlPoint.name;
      this.controlPoint.imagePath = controlPoint.imagePath;
      this.controlPoint.positionX = controlPoint.positionX;
      this.controlPoint.positionY = controlPoint.positionY;
      this.qrValue = "TCCP-" + controlPoint.id;
    },
    async deleteControlPoint() {
      try {
        this.isLoadingDetail = true;
        let id = this.controlPoint.id;
        const response = await this.$axios
          .delete("/GuardControlPoint/" + id)
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.getControlPoints();
        this.newControlPoint();
        alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingDetail = false;
      }
    },
    async saveControlPoint() {
      if (this.controlPoint.name == "") {
        alertify.warning("Lütfen kontrol noktası adı girin...");
        return;
      }
      this.isLoadingDetail = true;
      if (this.isNewControlPoint) {
        try {
          let controlPoint2 = this.controlPoint;
          const response = await this.$axios
            .post("/GuardControlPoint", {
              name: controlPoint2.name,
              areaId: controlPoint2.areaId,
              imagePath: controlPoint2.imagePath,
              positionX: controlPoint2.positionX,
              positionY: controlPoint2.positionY
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          if (response.status == 200) {
            alertify.success(this.$ml.get("alerts.savedSuccessfully"));
          } else {
            alertify.error(response.message);
          }
          this.getControlPoints();
          this.newControlPoint();
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoadingDetail = false;
        }
      } else {
        //GÜNCELLE
        try {
          let controlPoint2 = this.controlPoint;
          let image = this.imageData;
          const response = await this.$axios
            .put("/GuardControlPoint/" + controlPoint2.id, {
              name: controlPoint2.name,
              areaId: controlPoint2.areaId,
              imagePath: controlPoint2.imagePath,
              positionX: controlPoint2.positionX,
              positionY: controlPoint2.positionY
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          try {
            if (response.status == 200) {
              alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
            } else {
              alertify.error(response.message);
            }
          } catch (error) { }
          this.getControlPoints();
          this.newControlPoint();
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoadingDetail = false;
        }
      }
    },
    async getControlPoints() {
      try {
        this.isLoading = true;
        const controlPoints = [];
        const response = await this.$axios
          .get("/GuardControlPoint")
          .then(response => {
            response.data.forEach(doc => {
              controlPoints.push({
                id: doc.id,
                areaId: doc.areaId,
                name: doc.name,
                imagePath: doc.imagePath,
                positionX: doc.positionX,
                positionY: doc.positionY
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.controlPoints = controlPoints;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoading = false;
      }
    },
    async getAreas() {
      try {
        this.isLoading = true;
        const areas = [];
        const response = await this.$axios
          .get("/GuardArea")
          .then(response => {
            response.data.forEach(doc => {
              areas.push({
                id: doc.id,
                areaName: doc.areaName,
                imagePath: doc.imagePath
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.areas = areas;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoading = false;
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    await this.getAreas();
    await this.getControlPoints();
  }
};
</script>
<style scoped>
.box {
  min-height: 300px;
  height: 300px;
  max-height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/pages/guardTour/ControlPoints.vue